require("-!style-loader!css-loader!sass-loader!D:\\codebox\\devnest\\investup\\investup-web\\node_modules\\bootstrap-sass-loader\\bootstrap-sass-styles.loader.js!D:\\codebox\\devnest\\investup\\investup-web\\assets\\js\\bootstrap-sass-config.js");
require("-!D:\\codebox\\devnest\\investup\\investup-web\\node_modules\\bootstrap-sass-loader\\bootstrap-sass-scripts.loader.js!D:\\codebox\\devnest\\investup\\investup-web\\assets\\js\\bootstrap-sass-config.js");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass-loader/index.loader.js!./assets/js/bootstrap-sass-config.js
// module id = 1
// module chunks = 0